import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-042206cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = {
  key: 2,
  id: "zonesmobile",
  ref: "zones",
  class: "position-relative f-14 line-height-base line-height-small h-100"
}
const _hoisted_8 = {
  id: "zone-list",
  class: "list-unstyled rounded-xs mt-15 overflow-y-auto-hidden d-block border border-w-secondary shadow-none w-100",
  style: {"max-height":"400px"}
}
const _hoisted_9 = { class: "ms-10 mt-10 mb-5" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["data-place-id", "data-url", "title"]
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "accordion-item" }
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = ["data-bs-target", "aria-controls"]
const _hoisted_16 = ["id", "aria-labelledby"]
const _hoisted_17 = { class: "accordion-body py-0" }
const _hoisted_18 = {
  key: 1,
  class: "px-10 w-100"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["data-place-id", "data-url", "title"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  id: "place-boxes",
  class: "mb-30"
}
const _hoisted_23 = { class: "d-flex justify-content-between" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = {
  id: "map-boxes",
  class: "mb-30"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "fixed-bottom w-100 px-20 pb-5 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_autocomplete = _resolveComponent("base-autocomplete")!
  const _component_checkbox_btn = _resolveComponent("checkbox-btn")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_base_bt_modal = _resolveComponent("base-bt-modal")!

  return (_openBlock(), _createBlock(_component_base_bt_modal, {
    id: "place-modal",
    "data-cy": "place-modal",
    style: {"z-index":"1053"},
    "show-modal": _ctx.openPlaceModal,
    "custom-modal-header-classes": "d-flex p-0 py-15",
    "custom-modal-body-classes": "p-0",
    "custom-modal-footer-classes": "border-0 px-0",
    "custom-modal-content-classes": "overflow-hidden",
    "with-custom-footer": true,
    "with-close-icon": false,
    "full-height": true,
    onClosed: _ctx.hidePlaceModal
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("h2", {
        class: "f-18",
        innerHTML: _ctx.labels.choosePlace
      }, null, 8 /* PROPS */, _hoisted_1),
      _createElementVNode("button", {
        type: "button",
        class: "m-0",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["stop"]))
      }, [
        _createElementVNode("img", {
          src: `${_ctx.cdn}/_ui/img/Icons/Close-gs.svg`,
          class: "icon icon-md",
          alt: "Icona indietro"
        }, null, 8 /* PROPS */, _hoisted_2)
      ])
    ]),
    body: _withCtx(() => [
      (_ctx.valuation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_autocomplete, {
              id: "valuationAddress",
              "label-text": _ctx.labels.address,
              "model-value": _ctx.valuationAddress,
              "on-input-change-cb": _ctx.onInputChangeCb,
              "on-option-selected-cb": _ctx.optionSelectedCb,
              onChangedValue: _cache[1] || (_cache[1] = v => _ctx.valuationAddress = v)
            }, {
              righticon: _withCtx(({handleClean}) => [
                (`${_ctx.valuationAddress}`.length > 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `${_ctx.cdn}/_ui/img/Ico/close.svg`,
                      class: "text-input-icon right sm",
                      alt: "Clean Icon",
                      onClick: _withModifiers(($event: any) => {handleClean();}, ["stop"])
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label-text", "model-value", "on-input-change-cb", "on-option-selected-cb"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_base_autocomplete, {
              id: "place",
              "label-text": _ctx.labels.place,
              "model-value": _ctx.autocompleteValue,
              "on-input-change-cb": _ctx.getPlaceFn,
              "disable-cb": _ctx.disableCb,
              onChangedValue: _cache[2] || (_cache[2] = v => _ctx.autocompleteValue = v),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = obj => _ctx.managePlace(obj.payload)),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick()))
            }, {
              righticon: _withCtx(({handleClean}) => [
                (`${_ctx.autocompleteValue}`.length > 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `${_ctx.cdn}/_ui/img/Ico/close.svg`,
                      class: "text-input-icon right sm",
                      alt: "Clean Icon",
                      onClick: _withModifiers(($event: any) => {handleClean(); _ctx.clearCautocomplete()}, ["stop"])
                    }, null, 8 /* PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label-text", "model-value", "on-input-change-cb", "disable-cb"])
          ])),
      (!_ctx.areZonesAndLocalitiesEmpty() && _ctx.showZoneModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_checkbox_btn, {
                  id: "whole-municipality-checkbtn",
                  "data-cy": "whole-municipality-checkbtn",
                  class: "d-flex align-items-center",
                  "input-class": "flex-shrink-0",
                  label: _ctx.labels.wholeMunicipality,
                  checked: !_ctx.isZoneOrLocalitySelected() && !(Object.keys(_ctx.districtSelected).length > 0),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => {_ctx.onWholeMunicipalityClick(); _ctx.disableCb = true})
                }, null, 8 /* PROPS */, ["label", "checked"])
              ]),
              (_ctx.areZonesAndLocalitiesFilled())
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "select-group places-li-label",
                    innerHTML: _ctx.zonesLabel
                  }, null, 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, (zone) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: zone.zoneID,
                  ref_for: true,
                  ref: `zone${zone.zoneID}`,
                  "data-element": "",
                  "data-place-id": zone.placeID,
                  "data-url": zone.zoneURL,
                  title: zone.zoneName,
                  class: _normalizeClass([{'active' : _ctx.isZoneSelected(zone.zoneID)}, "px-0"])
                }, [
                  (zone.subPlaces.length>0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: 'accordionWrapper_'+zone.zoneID,
                        class: "accordion px-0 w-100",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent","stop"]))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_checkbox_btn, {
                              id: 'checkbox_' + zone.zoneID,
                              "data-id": 'checkbox_' + zone.zoneID,
                              "wrapper-margin-y": "py-15",
                              class: "d-inline-flex align-items-center w-auto mb-0 ms-10",
                              "input-class": "flex-shrink-0",
                              label: zone.zoneName,
                              "label-class": "fs-14 text-truncate cb-max-width lh-base",
                              "container-id": 'accordionWrapper_'+zone.zoneID,
                              checked: _ctx.isZoneSelected(zone.zoneID),
                              onChange: ($event: any) => {_ctx.removeTopLocalitySelected(); _ctx.onPlaceLIClick(zone, _ctx.updatePlaceName); _ctx.disableCb = true }
                            }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"]),
                            _createElementVNode("button", {
                              class: "accordion-button w-auto collapsed fs-14 d-inline-flex",
                              type: "button",
                              "data-bs-toggle": "collapse",
                              "data-bs-target": '#accordioItem_'+zone.zoneID,
                              "aria-expanded": "true",
                              "aria-controls": '#accordioItem_'+zone.zoneID
                            }, null, 8 /* PROPS */, _hoisted_15)
                          ]),
                          _createElementVNode("div", {
                            id: 'accordioItem_'+zone.zoneID,
                            class: "accordion-collapse collapse",
                            "aria-labelledby": 'accordioHeader_'+zone.zoneID
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.subPlaces, (district) => {
                                return (_openBlock(), _createBlock(_component_checkbox_btn, {
                                  id: district.districtID,
                                  key: district.districtID,
                                  "wrapper-margin-y": "py-15",
                                  class: "d-flex align-items-center mb-0",
                                  "input-class": "flex-shrink-0",
                                  label: district.districtName,
                                  "label-class": "fs-14 text-truncate cb-max-width lh-base",
                                  checked: _ctx.isDistrictSelected(district.zoneID,district.districtID) || _ctx.areAllDistrictsSelected(zone.zoneID),
                                  onChange: ($event: any) => {_ctx.onDistrictClick(zone,district,_ctx.updatePlaceName); _ctx.disableCb = true}
                                }, null, 8 /* PROPS */, ["id", "label", "checked", "onChange"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 8 /* PROPS */, _hoisted_16)
                        ])
                      ], 8 /* PROPS */, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_checkbox_btn, {
                          id: 'checkbox_' + zone.zoneID,
                          "data-id": 'checkbox_' + zone.zoneID,
                          label: zone.zoneName,
                          "wrapper-margin-y": "py-15",
                          class: "d-flex align-items-center mb-0",
                          "input-class": "flex-shrink-0",
                          "container-id": 'accordionWrapper_'+zone.zoneID,
                          "label-class": "w-100 fs-14 text-truncate cb-max-width lh-base",
                          checked: _ctx.isZoneSelected(zone.zoneID),
                          onChange: ($event: any) => {_ctx.removeTopLocalitySelected(); _ctx.onPlaceLIClick(zone, _ctx.updatePlaceName); _ctx.disableCb = true }
                        }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"])
                      ]))
                ], 10 /* CLASS, PROPS */, _hoisted_11))
              }), 128 /* KEYED_FRAGMENT */)),
              (_ctx.localityList.length)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "select-group places-li-label",
                    innerHTML: _ctx.localitiesLabel
                  }, null, 8 /* PROPS */, _hoisted_19))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localityList, (locality) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: locality.localityID,
                  "data-element": "",
                  "data-place-id": locality.placeID,
                  "data-url": locality.zoneURL,
                  title: locality.localityName
                }, [
                  _createCommentVNode(" TODO: da fixare dimensione del placeModal (si può scorrere verso il bassoptoy'9) "),
                  _createVNode(_component_radio_button, {
                    class: "mx-10 py-5 d-flex align-items-center",
                    "label-classes": "ps-10",
                    "is-checked": _ctx.isLocationSelected(locality.localityID),
                    label: locality.localityName,
                    onChange: ($event: any) => {_ctx.removeTopLocalitySelected(); _ctx.onPlaceLIClick(locality, _ctx.updatePlaceName, true); _ctx.disableCb = true}
                  }, null, 8 /* PROPS */, ["is-checked", "label", "onChange"])
                ], 8 /* PROPS */, _hoisted_20))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (!_ctx.valuation)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("p", {
              class: "f-14 mt-20 mb-10",
              innerHTML: _ctx.labels.rush
            }, null, 8 /* PROPS */, _hoisted_21),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.ROMA)))
                }, " Roma "),
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.MILANO)))
                }, " Milano "),
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.NAPOLI)))
                }, " Napoli ")
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.TORINO)))
                }, " Torino "),
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.PALERMO)))
                }, " Palermo "),
                _createElementVNode("div", {
                  class: "border border-w-secondary box-city f-14 d-flex justify-content-center py-10 my-5",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setTopPlace(_ctx.enumTopCities.GENOVA)))
                }, " Genova ")
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", {
                class: "f-16 text-capitalize",
                innerHTML: _ctx.labels.otherwise
              }, null, 8 /* PROPS */, _hoisted_26),
              _createElementVNode("a", {
                class: "nav-link text-w-primary btn-modal-search border border-w-secondary my-10 f-14 d-flex align-items-center fw-medium",
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => {_ctx.aroundMe=false; _ctx.openMapDraw()}, ["stop"]))
              }, [
                _createElementVNode("img", {
                  src: `${_ctx.cdn}/_ui/img/Ico/touch.svg`,
                  height: "16",
                  alt: "icona mappa",
                  class: "icon me-10"
                }, null, 8 /* PROPS */, _hoisted_27),
                _createTextVNode(" " + _toDisplayString(_ctx.labels.drawOnMap), 1 /* TEXT */)
              ]),
              _createElementVNode("a", {
                class: "nav-link text-w-primary btn-modal-search border border-w-secondary my-10 f-14 d-flex align-items-center fw-medium",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openMapAroundMe()))
              }, [
                _createElementVNode("img", {
                  src: `${_ctx.cdn}/_ui/img/Ico/geolocation-1.svg`,
                  height: "16",
                  alt: "icona ricerca",
                  class: "icon me-10"
                }, null, 8 /* PROPS */, _hoisted_28),
                _createTextVNode(" " + _toDisplayString(_ctx.labels.closeOnYou), 1 /* TEXT */)
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ((_ctx.cityModal && !_ctx.valuation && _ctx.placeTest.cityID !==null) || _ctx.showZoneModal)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "btn btn-w-primary btn-block",
                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.confirmPlace()), ["stop"]))
              }, _toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-modal", "onClosed"]))
}